'use strict';

((createApp, fetch, location, URLSearchParams) => {
  createApp({
    data () {
      return {
        page: 1,
        pageSize: 25,
        searchText: '',
        treatments: [],
        treatmentsInit: [],
        selectedItem: null
      };
    },
    methods: {
      async fetchJson (url) {
        return fetch(url).then((response) => response.json());
      },
      search () {
        this.fetchJson(`/api/treatments?search=${this.searchText}`)
          .then((treatments) => {
            this.treatments = treatments;
          });
      },
      setHash (key, value) {
        const hashParams = new URLSearchParams(window.location.hash.replace('#', '?'));
        hashParams.set(key, value);
        location.hash = hashParams.toString().replace('?', '#');
      },
      readHash (key) {
        if (!location.hash) {
          this.selectedItem = null;
          return;
        }
        const hashParams = new URLSearchParams(window.location.hash.replace('#', '?'));
        return hashParams.get(key);
      },
      selectItem (item) {
        this.selectedItem = item;
        this.setHash('treatment', item.name);
      }
    },
    watch: {
      searchText (newValue) {
        if (newValue?.length > 2)
          this.search();
        else
          this.treatments = [...this.treatmentsInit];
      }
    },
    async created () {
      this.treatmentsInit = await this.fetchJson('/api/treatments');
      this.treatments = [...this.treatmentsInit];
      const s = this.readHash('treatment');
      if (s)
        this.selectedItem = this.treatments.find(i => i.name === s);
      else
        this.selectedItem = this.treatments[0];
      window.scope = this;
    }
  }).mount('#app');
})(window.Vue.createApp, window.fetch, window.location, window.URLSearchParams);
